<template>
    <div v-if="value">
        <input-text
            :label="_mft('form:field.title.label')"
            :required="true"
            v-model:content="value.title"
        />
        <toggle-switch
            :label="_mft('form:required')"
            v-model:content="value.required"
        ></toggle-switch>

        <toggle-switch
            :label="_mft('form:field.showMoreInfo')"
            v-model:content="value.showInstructions"
        ></toggle-switch>

        <Instructions
            :model-value="value"
        />
    </div>
    <mf-spinner-medium v-else class="w-16 h-8"></mf-spinner-medium>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
import Instructions from './_instructions.vue'

export default {
    components: {Instructions},
    props: {
        modelValue: {},
    },
    emits: [
        'update:modelValue'
    ],
    data() {
        return {
            value: null,
            showInstructions: false,
        };
    },
    async mounted() {
        this.captureModelValue();
    },
    watch: {
        modelValue() {
            if (JSON.stringify(this.value) === JSON.stringify(this.modelValue)) { return; }
            this.captureModelValue();
        },
        value: {
            handler() {
                this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.value)));
            },
            deep: true
        },
    },
    methods: {
        captureModelValue() {
            const value = this.modelValue ? JSON.parse(JSON.stringify(this.modelValue)) : {};
            if (!value.uuid) { value.uuid = uuidv4(); }
            if (!value.title) { value.title = null; }
            if (!value.showInstructions) { value.showInstructions = false; }
            if (!value.metaText) { value.metaText = null; }
            if (!value.metaImage) { value.metaImage = null; }
            if (!value.metaVideo) { value.metaVideo = null; }
            if (!value.required) { value.required = false; }
            this.value = value;
        }
    },
}
</script>
